import { type TracksStore, TrackType } from '@/shared/store/tracks.store.tsx'
import type {
  AudioFormAssets,
  AudioFormLayer,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { trackVolumeToGain } from './track-volume-to-gain.ts'

export const mapMediaFilesToAudioformLayers = (
  trackStore: TracksStore,
  assets: AudioFormAssets
): AudioFormLayer[] => {
  const mediaFileTracks = trackStore.tracks.filter(
    (track) => track.type === TrackType.MediaFiles
  )

  return mediaFileTracks.map((track) => {
    const gain = trackVolumeToGain(track.volume)
    const sortedClips = track.clips
      .filter(
        (clip): clip is typeof clip & { startAt: number } =>
          clip.startAt !== undefined
      )
      .sort((a, b) => a.startAt + a.startOffset - (b.startAt + b.startOffset))

    let previousEnding = 0

    const clips = sortedClips.flatMap((md) => {
      const assetRef = Object.entries(assets).find(
        ([, asset]) => asset.type === 'media' && asset.fileId === md.mediaId
      )?.[0]

      if (!assetRef) {
        return []
      }

      const marginStart = md.startAt + md.startOffset - previousEnding
      previousEnding = md.startAt + md.duration + md.endOffset

      return [
        {
          assetRef,
          ...(md.fadeIn > 0 && { fadeIn: md.fadeIn }),
          ...(md.fadeOut > 0 && { fadeOut: md.fadeOut }),
          ...(md.startOffset > 0 && { readPosition: md.startOffset }),
          forcedDuration: md.duration - md.startOffset + md.endOffset,
          marginStart: Math.max(marginStart, 0),
          gain,
        },
      ]
    })

    return { clips }
  })
}
